import changeStatus from './changeStatus.js'
import transfer from './transfer.js'

export default {
    changeStatus,
    transfer,
}